import moment from "moment";
import { Overlay } from "./styles"

interface Props {
    valor:any,
    Status:any,
    dataPagamento:any,
    FormaPagamento:any,
    saidaId:any,
    despesa:any,
    colaborador:any,
    editarSaida:any
}

export default function CommentBoxSaida({
    valor,
    Status,
    dataPagamento,
    FormaPagamento,
    despesa,
    colaborador,
    saidaId,
    editarSaida

}:Props) {

    return (
        <Overlay>
            <div className="comment-box">
                <div className="comment-icon">💬{despesa} {colaborador}</div>
                <div className="comment-text">
                    
                    Valor Liquido: <b>{parseFloat(valor).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    })}</b>
                    <br />
                    Status: <b style={{textTransform:'uppercase'}}>{Status}</b>
                    <br />
                    Data de Pagamento: <b>{Status == 'pago' && moment(dataPagamento).format('DD/MM/YYYY')}</b>
                    <br /> 
                    Forma de Pagamento: <b>{FormaPagamento}</b>
                    <br /> 
                    
                </div>
                <div className="comment-button">
                    <button type="button" style={{display:'inline-block',height:'30px', textAlign:'center', alignItems:'center', width:'50%'}} className="btn btn-success" onClick={editarSaida}>Editar Saida</button>
                </div>
            </div>
        </Overlay>
      
    );
}

